import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import {} from "axios";
import { BFormInput } from "bootstrap-vue";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { createWorkflow } from "@/components/Workflow/workflows.services";
import { Toast } from "@/composables/toast";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowCreate',
    props: {
        showHeading: { type: Boolean }
    },
    setup(__props) {
        library.add(faCheck);
        const router = useRouter();
        const workflowAnnotation = ref("");
        const workflowName = ref("Unnamed workflow");
        const workflowNameInput = ref(null);
        async function onCreate() {
            try {
                const data = await createWorkflow(workflowName.value, workflowAnnotation.value);
                Toast.success(data.message);
                router.push(`/workflows/edit?id=${data.id}`);
            }
            catch (e) {
                const error = e;
                Toast.error(error.response?.data.err_msg ?? "Failed to create workflow");
            }
        }
        return { __sfc: true, router, workflowAnnotation, workflowName, workflowNameInput, onCreate, faCheck, BFormInput, AsyncButton, Heading };
    }
});
